import { classNamePrefix as prefixCt } from "@/utils/common";
import "./index.less";

export default class taskListRender {
  fragmentCls: string;

  config: Record<string, any>;

  constructor(config = {}) {
    this.fragmentCls = `.${prefixCt("task-list")}`;
    this.config = config;
  }
}
